export const languageConstants = {
  DEFAULT_LOCALE: "en",
  LANGUAGE: "SELECT_LANGUAGE",
  CHANGE_LANGUAGE_REQUEST: "CHANGE_LANGUAGE_REQUEST",
  CHANGE_LANGUAGE_SUCCESS: "CHANGE_LANGUAGE_SUCCESS",
  CHANGE_LANGUAGE_FAILURE: "CHANGE_LANGUAGE_FAILURE"
};
